import script from "./mark-proposal-as-finalized-btn.vue?vue&type=script&setup=true&lang=ts"
export * from "./mark-proposal-as-finalized-btn.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__